// extracted by mini-css-extract-plugin
export default {"backNavigationBtn":"backNavigationBtnStyles_backNavigationBtn__3Zn2R","backNavigationBtnText":"backNavigationBtnStyles_backNavigationBtnText__ZaU17"};